exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ticketOrigin_0 {\n    color: #9b9b9b;\n    padding: 0 3px;\n    border-radius: 3px;\n    border: 1px solid #f5f1f1;\n    display: inline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3cc4a735","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketOrigin.vue
// module id = 885
// module chunks = 75